import { kebabCase } from 'lodash';
import Image from 'next/image';

import { InfoTag } from '@/components/alert';
import { LinksBlock, type LinksBlockProps } from '@/components/links-block';
import { Text } from '@/components/text';
import { TextLayout } from '@/components/text-layout';

type StaticImageBlockProps = {
  heading: string;
  body?: string;
  alertMessage?: string;
  image: {
    url: string;
    width: number;
    height: number;
    description: string;
  };
  linksBlock?: LinksBlockProps;
};
export const StaticImageBlock = ({
  heading,
  body,
  alertMessage,
  image,
  linksBlock,
}: StaticImageBlockProps) => (
  <div
    id={kebabCase(heading)}
    className="container"
  >
    <div className="grid grid-cols-1 sm:grid-cols-6 lg:grid-cols-2">
      <div className="col-span-1 overflow-hidden rounded-rad-b max-lg:mb-c sm:col-span-2 sm:col-start-3 md:col-span-2 md:max-lg:col-start-3 lg:order-first lg:col-span-1 lg:h-[30rem]">
        {image.url && image.width && image.height ? (
          <Image
            src={image.url}
            width={image.width}
            height={image.height}
            alt={image.description}
            className="h-full w-full object-cover"
          />
        ) : null}
      </div>
      <div className="col-span-1 flex flex-col justify-center gap-c max-lg:text-center sm:col-span-6 md:max-lg:items-center lg:order-last lg:col-span-1 lg:pl-d">
        {alertMessage ? (
          <div className="max-lg:mx-auto">
            <InfoTag>
              <Text
                variant="body2"
                as="p"
                className="leading-none"
              >
                {alertMessage}
              </Text>
            </InfoTag>
          </div>
        ) : null}
        <div>
          <TextLayout
            headingAccent="responsive"
            buttonLayoutVariant="stackedCenter"
            heading={heading}
            body={body}
          />
        </div>
        {linksBlock ? (
          <LinksBlock
            header={linksBlock.header}
            links={linksBlock.links}
          />
        ) : null}
      </div>
    </div>
  </div>
);
